
export const getUsuarios = (numeroIdentificacion) => {
    let urlParam = (numeroIdentificacion === null || numeroIdentificacion === '') ? '' : `?numero_identificacion=${numeroIdentificacion}`;
    return (dispatch) => {
        dispatch({type: "USERS_LOADING"});
        let headers = {"Content-Type": "application/json"};
        if(!!localStorage.getItem('token_cafe')){
            headers["Authorization"] = `Bearer ${localStorage.getItem('token_cafe')}`;
            return fetch(`${process.env.REACT_APP_API_URL}/users/get-all-users${urlParam}`, {headers, method: "GET"}).then((res) => {
                if(res.status === 200){
                    res.json().then(res => {
                        if(res.data !== null){
                            dispatch({type: "USERS_LOAD_SUCCESS", data: res.data});
                        }else{
                            dispatch({type: "USERS_LOAD_FAILED", data: 'Ha ocurrido un error en la carga de datos'});
                        }
                    }).catch(err => {
                        dispatch({type: "USERS_LOAD_FAILED", data: 'Ha ocurrido un error en la carga de datos.'});
                    });
                }else{
                    dispatch({type: "USERS_LOAD_FAILED", data: 'Ha ocurrido un error en la carga de datos.'});
                }
            }).catch((err) => {
                dispatch({type: "USERS_LOAD_FAILED", data: 'Ha ocurrido un error en la carga de datos.'});
            });
        }else{
            dispatch({type: "USERS_LOAD_FAILED", data: 'Ha ocurrido un error en la carga de datos.'});
        }
    }
};


export const addUsuario = (usuario) => {
    return (dispatch) => {
        dispatch({type: "SEND_USER_LOADING"});
        let headers = {"Content-Type": "application/json"};
        if(!!localStorage.getItem('token_cafe')){
            headers["Authorization"] = `Bearer ${localStorage.getItem('token_cafe')}`;
            const body = JSON.stringify(usuario);
            return fetch(`${process.env.REACT_APP_API_URL}/users/add`, {headers, body, method: "POST"}).then((res) => {
                if(res.status === 200){
                    res.json().then(res => {
                        if(res.data !== null){
                            dispatch({type: "SEND_USER_SUCCESS", data: 'Se ha creado un nuevo usuario.'});
                        }else{
                            dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
                        }
                    }).catch(err => {
                        dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
                    });
                }else{
                    dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
                }
            }).catch((err) => {
                dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
            });
        }else{
            dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
        }
    }
};

export const editUsuario = (usuario) => {
    return (dispatch) => {
        dispatch({type: "SEND_USER_LOADING"});
        let headers = {"Content-Type": "application/json"};
        if(!!localStorage.getItem('token_cafe')){
            headers["Authorization"] = `Bearer ${localStorage.getItem('token_cafe')}`;
            const body = JSON.stringify(usuario);
            return fetch(`${process.env.REACT_APP_API_URL}/users/edit/${usuario.id}`, {headers, body , method: "PUT"}).then((res) => {
                if(res.status === 200){
                    res.json().then(res => {
                        if(res.data !== null){
                            dispatch({type: "SEND_USER_SUCCESS", data: 'Se han actualizado los datos del usuario'});
                        }else{
                            dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
                        }

                    }).catch(err => {
                        dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
                    });
                }else{
                    dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
                }
            }).catch((err) => {
                dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
            });
        }else{
            dispatch({type: "SEND_USER_FAILED", data: 'Ha ocurrido un error en la actualización de la base de datos.'});
        }
    }
};